import React, {Component} from 'react';
import PropTypes from 'prop-types';
import '../Widgets.scss';
import './LkWidget.scss';
import Loader from '../../shared/Loader/Loader';

class LkWidget extends Component {
    static propTypes = {
        userInfo: PropTypes.object,
        classPrefix: PropTypes.string,
    }
    constructor(props) {
        super(props)
        this.pageSetting = {
            title: 'Мои контракты'
        }
        this.state = {

        }

    }

    render() {
        const {classPrefix} = this.props;
        const {title} = this.pageSetting;
        return (<div className={`contentBody${classPrefix}`}>
            <div className={'widgetTitle'}>
                {title}
            </div>
            <div className={'widgetContent'}>
                <div className={'emptyBlock'}>
                    <div>Раздел поставок на этапах Коммерческого предложения и Заключения договора</div>
                    <Loader/>
                </div>
            </div>
        </div>)
    }
}

export default LkWidget



// WEBPACK FOOTER //
// ./src/Widget/LkWidget/LkWidget.js